import styles from "./Dashboard.module.css";

import { useState } from "react";

type ExperimentOption = {
  id: string;
  label: string;
};

type ExperimentDropdownProps = {
  options?: ExperimentOption[];
  selectedId?: string;
  onSelect?: (id: string) => void;
  title?: string;
  selectLabel?: string;
  /** When selectedId is missing/invalid, pick the last option (newest) instead of the first. */
  preferLatest?: boolean;
};

const defaultExperiments: ExperimentOption[] = [
  { id: "exp-1", label: "Experiment #1" },
  { id: "exp-2", label: "Experiment #2" },
];

const ExperimentDropdown = ({
  options = defaultExperiments,
  selectedId,
  onSelect,
  title = "Dashboard",
  selectLabel = "Select Experiment",
  preferLatest = false,
}: ExperimentDropdownProps) => {
  const [open, setOpen] = useState(false);
  const fallbackId = preferLatest
    ? options[options.length - 1]?.id || options[0]?.id || ""
    : options[0]?.id || "";
  const matched = selectedId && options.some((o) => o.id === selectedId) ? selectedId : null;
  const currentSelectedId = matched || fallbackId;
  const selectedLabel =
    options.find((o) => o.id === currentSelectedId)?.label || selectLabel;

  const handleSelect = (id: string) => {
    onSelect?.(id);
    setOpen(false);
  };

  return (
    <div className={styles.experimentDropdown}>
      {title ? <h1 className={styles.experimentDropdown_title}>{title}</h1> : null}
      {title ? <div className={styles.divider} /> : null}
      <div className={styles.experimentDropdown_content}>
        <span className={styles.experimentDropdown_content_title}>{selectLabel}</span>
        <div className={styles.experimentDropdown_menuWrapper}>
          <button
            type="button"
            className={styles.experiment_dropdown}
            onClick={() => setOpen((prev) => !prev)}
            aria-haspopup="listbox"
            aria-expanded={open}
          >
            <span>{selectedLabel}</span>
            <span className={styles.experiment_dropdown_arrow} />
          </button>
          {open ? (
            <div className={styles.experimentDropdown_menu} role="listbox">
              {options.map((item) => (
                <div
                  key={item.id}
                  className={styles.experimentDropdown_menuItem}
                  role="option"
                  aria-selected={item.id === currentSelectedId}
                  onClick={() => handleSelect(item.id)}
                >
                  <span
                    className={
                      item.id === currentSelectedId
                        ? styles.experimentDropdown_menuItem_active
                        : undefined
                    }
                  >
                    {item.label}
                  </span>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ExperimentDropdown;